import React, { useState } from "react";
import { Modal, ModalFooter, ModalHeader, ModalBody } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import { handleErrors } from "../../services/handleErrors";
import SpinnerButton from "../../components/Button";

function RatingScaleModal({ toggle, isOpen, ticket, handleTicketSave }) {
  const [optionSelected, setOptionSelected] = useState(ticket.valoracion || null);
  const [showError, setShowError] = useState(false);

  const handleSelectOption = (option) => {
    if (optionSelected === option) {
      setOptionSelected(null);
    } else {
      setOptionSelected(option);
    }
  };
  const valoracionError = () => {
    let error = "";
    if (!optionSelected) {
      error = "Debe seleccionar una valoración";
    }

    return error;
  };
  const messageError = valoracionError();
  const formik = useFormik({
    initialValues: {
      comentario: ticket.valoracionComentario || "",
    },
    onSubmit: async (values) => {
      const { comentario } = values;
      try {
        // submit
        if (optionSelected) {
          const valoracionTotal = { valoracion: optionSelected, valoracionComentario: comentario };
          // console.log("valoracion", valoracion);
          handleTicketSave(valoracionTotal);
          toast.success("valoración guardada");
          toggle();
        } else {
          setShowError(true);
        }
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
      }
    },
    validationSchema: Yup.object().shape({
      comentario: Yup.string(),
    }),
  });
  return (
    <Modal centered backdrop="static" isOpen={isOpen} toggle={toggle} size="lg">
      <div>
        <ModalHeader className="border-0 pb-0" toggle={toggle}>
          <p className="text" style={{ fontSize: "14px" }}>
            En general, ¿cuál es el grado de satisfacción con la forma en la que hemos gestionado tu consulta?
          </p>
        </ModalHeader>
        <form className="theme-form" onSubmit={formik.handleSubmit}>
          <ModalBody>
            <div className="d-flex mx-3">
              <button
                id="option1"
                type="button"
                className={`rating-scale m-1 ${optionSelected === 1 ? "selected" : ""}`}
                aria-label="option-1"
                onClick={() => handleSelectOption(1)}
              >
                <FontAwesomeIcon color="#e82e2e" size="3x" icon="fa-regular fa-face-angry" />
                <h6 className="mt-2  p-2 rounded d-flex">Muy insatisfecho</h6>
              </button>
              <button
                id="option2"
                type="button"
                className={`rating-scale m-1 ${optionSelected === 2 ? "selected" : ""}`}
                aria-label="option-2"
                onClick={() => handleSelectOption(2)}
              >
                <FontAwesomeIcon color="orange" size="3x" icon="fa-regular fa-face-frown" />
                <h6 className="mt-2  p-2 rounded">Insatisfecho</h6>
              </button>
              <button
                id="option3"
                type="button"
                className={`rating-scale m-1 ${optionSelected === 3 ? "selected" : ""}`}
                aria-label="option-3"
                onClick={() => handleSelectOption(3)}
              >
                <FontAwesomeIcon color="lightgreen" size="3x" icon="fa-regular fa-face-smile" />
                <h6 className="mt-2  p-2 rounded">Satisfecho</h6>
              </button>
              <button
                id="option4"
                type="button"
                className={`rating-scale m-1 ${optionSelected === 4 ? "selected" : ""}`}
                aria-label="option-4"
                onClick={() => handleSelectOption(4)}
              >
                <FontAwesomeIcon color="green" size="3x" icon="fa-regular fa-face-smile-beam" />
                <h6 className="mt-2  p-2 rounded">Muy satisfecho</h6>
              </button>
            </div>
            {messageError && showError && <div className="input-feedback">{messageError}</div>}
            <div className="col-sm-12 mb-3">
              <div className="form-group">
                <label className="col-form-label w-100" htmlFor="comentarios">
                  ¿Tienes algún comentario adicional?
                  <textarea
                    className="form-control"
                    id="comentario"
                    rows="3"
                    // placeholder="Comentario"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.comentario}
                  />
                </label>
              </div>
            </div>
          </ModalBody>
          <ModalFooter className="border-0 pt-0">
            <div className="mb-0 px-3 w-100 d-flex justify-content-end">
              <SpinnerButton className="btn btn-light" type="button" onClick={toggle}>
                Cancelar
              </SpinnerButton>
              <SpinnerButton color="btn btn-primary" disabled={formik.isSubmitting} isLoading={formik.isSubmitting} type="submit">
                Confirmar
              </SpinnerButton>
            </div>
          </ModalFooter>
        </form>
      </div>
    </Modal>
  );
}

export default RatingScaleModal;
